const picklistStatus :any = {
  PICKLIST_CREATED: 'CREATED',
  PICKLIST_PICKING: 'PICKING IN-PROGRESS',
  PICKLIST_PICKED: 'PACKING',
  NOT_IN_PICKING: 'NOT CREATED',
  NO_ENOUGH_STOCKS: 'NOT ENOUGH STOCKS',
  PICKLIST_PACKED: 'COMPLETED',
};

export const PicklistConfig = {
  picklistStatus,
};
